import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  column: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    justifyContent: 'flex-start',
  },
  button: {
    marginTop: '0.5em',
  },
  stopButton: {
    marginTop: '0.5em',
    backgroundColor: '#ff6b35',
    color: '#ffffff',
    '&:hover': {
      backgroundColor: '#e85a2a',
    },
  },
  rowTimezone: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
  },
  inputTimezone: {
    display: 'flex',
    flexGrow: 1,
    marginRight: '1em',
  },
  inputReinforcement: {
    display: 'flex',
    alignSelf: 'center',
  },
  loading: {
    margin: theme.spacing(3, 0, 2),
    alignSelf: 'center',
  },
}));
